export const SET_TOPIC_UIDS = "setTopicUids";
export const SET_ERROR = "setError";
export const SET_LOADED = "setLoaded";
